<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex xs6 offset-sm3>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">{{responseError}}</span>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="code"
                  label="Finance Setting Code"
                  type="text"
                  :rules="rules.codeRules"
                  v-model="financeSetting.code"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="financialYearName"
                  label="Financial Year Name"
                  type="text"
                  :rules="rules.financialYearRules"
                  v-model="financeSetting.financialYearName"
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <v-menu
                  ref="menu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="financeSetting.startMonth"
                      label="Start Month"
                      prepend-icon="event"
                      readonly
                      :rules="rules.startMonthRules"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="financeSetting.startMonth" type="month"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex>
                <v-menu
                  ref="menu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="financeSetting.endMonth"
                      label="End Month"
                      prepend-icon="event"
                      readonly
                      :rules="rules.endMonthRules"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="financeSetting.endMonth" type="month"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  type="text"
                  v-model="financeSetting.description"
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="financeSetting.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="financeSetting.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="financeSetting.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="financeSetting.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm12 v-if="financeSetting.id">
                <v-text-field
                  name="updatedBy"
                  label="Updated By"
                  v-model="financeSetting.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn type="submit" color="primary" :loading="saveLoading">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>
<script>
import { FinanceSetting } from "../../models/model";
import { financeSettingService } from "../../services/finance-setting-service";
import { FinanceSettingFormRules } from "../../helpers/validation-rules";
import { commonService } from "../../services/common-service";
export default {
  name: "FinanceSettingDetail",
  data: () => ({
    valid: true,
    breadcrumbs: [
      {
        text: "Finance Setting",
        disabled: true,
      },
      {
        text: "Finance Setting Detail",
        disabled: true,
      },
    ],
    responseError: "",
    createdDate: "",
    updatedDate: "",
    financeSetting: new FinanceSetting(),
    oldFinanceSession: new FinanceSetting(),
    saveLoading: false,
    rules: new FinanceSettingFormRules(),
  }),
  created() {
    const id = this.$route.params.id;
    if (id == "new") {
      //new finance setting
    } else {
      this.getFinanceSettingDetail(id);
    }
  },
  methods: {
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        let financeSettingObj = {
          id: this.financeSetting.id ? this.financeSetting.id : "",
          code: this.financeSetting.code ? this.financeSetting.code : "",
          financialYearName: this.financeSetting.financialYearName
            ? this.financeSetting.financialYearName
            : "",
          startMonth: this.financeSetting.startMonth
            ? this.financeSetting.startMonth
            : "",
          endMonth: this.financeSetting.endMonth
            ? this.financeSetting.endMonth
            : "",
          description: this.financeSetting.description
            ? this.financeSetting.description
            : "",
        };
        financeSettingService
          .saveFinanceSetting(financeSettingObj)
          .then((res) => {
            console.log(res);
            this.goBack();
          })
          .catch((err) => {
            if (err.response.data) {
              this.responseError = err.response.data.message;
            }
            this.saveLoading = false;
          });
      }
    },
    goBack() {
      this.$router.push("/finance-settings");
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.financeSetting.id) {
        this.financeSetting = new FinanceSetting();
      } else {
        this.financeSetting = Object.assign({}, this.oldFinanceSession);
      }
    },
    getFinanceSettingDetail(id) {
      financeSettingService.getFinanceSettingDetail(id).then((res) => {
        this.financeSetting = res.data;
        this.createdDate = commonService.formatDate(
          new Date(this.financeSetting.createdDateInMilliSeconds)
            .toISOString()
            .substr(0, 10),
          "YYYY-MM-DD"
        );
        this.updatedDate = commonService.formatDate(
          new Date(this.financeSetting.updatedDateInMilliSeconds)
            .toISOString()
            .substr(0, 10),
          "YYYY-MM-DD"
        );
        this.oldFinanceSession = Object.assign({}, res.data);
      });
    },
  },
};
</script>